let audioCtx = null;

const playAudio = function playAudio(audio, loop, volume) {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  const xhr = new XMLHttpRequest();
  xhr.open('GET', audio.src);
  xhr.responseType = 'arraybuffer';
  const source = audioCtx.createBufferSource();
  xhr.addEventListener('load', () => {
    const playsound = (audioBuffer) => {
      source.buffer = audioBuffer;
      source.connect(audioCtx.destination);
      source.loop = loop;
      source.start();
    };
    audioCtx.decodeAudioData(xhr.response).then(playsound);
  });
  xhr.send();
  return source;
};

const destroyAudioContext = function destroyAudioContext() {
  if (audioCtx) {
    audioCtx.close();
  }
};

const createAudioApi = function () {
  const audioApi = {
    destroy: destroyAudioContext,
    play: playAudio,
    audioCtx,
  };
  return audioApi;
};

export { playAudio, createAudioApi };
